
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tg-earn",
      function () {
        return require("private-next-pages/tg-earn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tg-earn"])
      });
    }
  